import React, { useEffect, useState, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Sidebar icons LIGHT
import { ReactComponent as ChargingSessionActive } from '../../assets/icons/sidebar/charging-session-dark.svg';
import { ReactComponent as ChargingSession } from '../../assets/icons/sidebar/charging-session.svg';
import { ReactComponent as AccountActiveIconLight } from '../../assets/icons/sidebar/sidebar-account-active.svg';
import { ReactComponent as AccountIconLight } from '../../assets/icons/sidebar/sidebar-account.svg';
import { ReactComponent as DashboardActiveIconLight } from '../../assets/icons/sidebar/sidebar-dashboard-active.svg';
import { ReactComponent as DashboardIconLight } from '../../assets/icons/sidebar/sidebar-dashboard.svg';
import { ReactComponent as DeviceActiveIconLight } from '../../assets/icons/sidebar/sidebar-device-active.svg';
import { ReactComponent as DeviceIconLight } from '../../assets/icons/sidebar/sidebar-device.svg';
import { ReactComponent as FacilityActiveIconLight } from '../../assets/icons/sidebar/sidebar-facility-active.svg';
import { ReactComponent as FacilityIconLight } from '../../assets/icons/sidebar/sidebar-facility.svg';
import { ReactComponent as GuestActiveLight } from '../../assets/icons/sidebar/sidebar-guest-active.svg';
import { ReactComponent as GuestIconLight } from '../../assets/icons/sidebar/sidebar-guest-icon.svg';
// import { ReactComponent as HomeActiveIconLight } from '../../assets/icons/sidebar/sidebar-home-active.svg';
// import { ReactComponent as HomeIconLight } from '../../assets/icons/sidebar/sidebar-home.svg';
import { ReactComponent as MaintenanceActiveIconLight } from '../../assets/icons/sidebar/sidebar-maintenance-active.svg';
import { ReactComponent as MaintenanceIconLight } from '../../assets/icons/sidebar/sidebar-maintenance.svg';
import { ReactComponent as PricingActiveLight } from '../../assets/icons/sidebar/sidebar-pricing-active.svg';
import { ReactComponent as PricingLight } from '../../assets/icons/sidebar/sidebar-pricing.svg';
import { ReactComponent as ReportActiveLight } from '../../assets/icons/sidebar/sidebar-report-active.svg';
import { ReactComponent as ReportIconLight } from '../../assets/icons/sidebar/sidebar-report-icon.svg';
import { ReactComponent as ScheduleActiveIconLight } from '../../assets/icons/sidebar/sidebar-schedule-active.svg';
import { ReactComponent as ScheduleIconLight } from '../../assets/icons/sidebar/sidebar-schedule.svg';
import { ReactComponent as TransactionActiveIconLight } from '../../assets/icons/sidebar/sidebar-transaction-active.svg';
import { ReactComponent as TransactionIconLight } from '../../assets/icons/sidebar/sidebar-transaction.svg';
import { ReactComponent as UserIconActiveLight } from '../../assets/icons/sidebar/sidebar-user-active.svg';
import { ReactComponent as UserIconLight } from '../../assets/icons/sidebar/sidebar-user.svg';
import { ReactComponent as VlbcIconLight } from '../../assets/icons/sidebar/vlbc-black-icon.svg';
import { ReactComponent as VlbcActiveLight } from '../../assets/icons/sidebar/vlbc-white-icon.svg';
// Sidebar icons DARK
import { ReactComponent as ChargingActiveSessionDark } from '../../assets/icons/sidebarDark/charging-session-active-dark.svg';
import { ReactComponent as ChargingSessionDark } from '../../assets/icons/sidebarDark/charging-session-dark.svg';
import { ReactComponent as DashboardActiveIconDark } from '../../assets/icons/sidebarDark/sidebar-dashboard-active-dark.svg';
import { ReactComponent as DashboardIconDark } from '../../assets/icons/sidebarDark/sidebar-dashboard-dark.svg';
import { ReactComponent as DeviceActiveIconDark } from '../../assets/icons/sidebarDark/sidebar-device-active-dark.svg';
import { ReactComponent as DeviceIconDark } from '../../assets/icons/sidebarDark/sidebar-device-dark.svg';
import { ReactComponent as PricingActiveDark } from '../../assets/icons/sidebarDark/sidebar-dynamicPricing-active-dark.svg';
import { ReactComponent as PricingDark } from '../../assets/icons/sidebarDark/sidebar-dynamicPricing-dark.svg';
import { ReactComponent as FacilityActiveIconDark } from '../../assets/icons/sidebarDark/sidebar-facility-active-dark.svg';
import { ReactComponent as FacilityIconDark } from '../../assets/icons/sidebarDark/sidebar-facility-dark.svg';
import { ReactComponent as GuestActiveDark } from '../../assets/icons/sidebarDark/sidebar-guest-active-dark.svg';
import { ReactComponent as GuestIconDark } from '../../assets/icons/sidebarDark/sidebar-guest-dark.svg';
// import { ReactComponent as HomeIconActiveDark } from '../../assets/icons/sidebarDark/sidebar-home-active-dark.svg';
// import { ReactComponent as HomeIconDark } from '../../assets/icons/sidebarDark/sidebar-home-dark.svg';
import { ReactComponent as MaintenanceActiveIconDark } from '../../assets/icons/sidebarDark/sidebar-maintenance-active-dark.svg';
import { ReactComponent as MaintenanceIconDark } from '../../assets/icons/sidebarDark/sidebar-maintenance-dark.svg';
import { ReactComponent as ReportActiveDark } from '../../assets/icons/sidebarDark/sidebar-reports-active-dark.svg';
import { ReactComponent as ReportIconDark } from '../../assets/icons/sidebarDark/sidebar-reports-dark.svg';
import { ReactComponent as ScheduleActiveIconDark } from '../../assets/icons/sidebarDark/sidebar-schedule-active-dark.svg';
import { ReactComponent as ScheduleIconDark } from '../../assets/icons/sidebarDark/sidebar-schedule-dark.svg';
import { ReactComponent as AccountActiveIconDark } from '../../assets/icons/sidebarDark/sidebar-station-active-dark.svg';
import { ReactComponent as AccountIconDark } from '../../assets/icons/sidebarDark/sidebar-station-dark.svg';
import { ReactComponent as ToggleCloseDark } from '../../assets/icons/sidebarDark/sidebar-toggle-close-dark.svg';
import { ReactComponent as ToggleOpenDark } from '../../assets/icons/sidebarDark/sidebar-toggle-open-dark.svg';
import { ReactComponent as TransactionActiveIconDark } from '../../assets/icons/sidebarDark/sidebar-transaction-active-dark.svg';
import { ReactComponent as TransactionIconDark } from '../../assets/icons/sidebarDark/sidebar-transaction-dark.svg';
import { ReactComponent as UserIconActiveDark } from '../../assets/icons/sidebarDark/sidebar-user-active-dark.svg';
import { ReactComponent as UserIconDark } from '../../assets/icons/sidebarDark/sidebar-user-dark.svg';
// Toggle
import { ReactComponent as ToggleCloseLight } from '../../assets/icons/toggle-close.svg';
import { ReactComponent as ToggleOpenLight } from '../../assets/icons/toggle-open.svg';
import ThemeContext from '../../contexts/theme-context/ThemeContext';
import { checkPermission } from '../../shared-functions/JWTDocodeFunction';

// Define types for menu items
interface MenuItem {
  id: number;
  label: string;
  isActive: boolean;
  allow: boolean;
  url: string;
  svgIcon: React.ReactNode | (() => React.ReactNode);
  activeSvgIcon: React.ReactNode | (() => React.ReactNode);
}

/**
 * renderIcon component
 */
const renderIcon = (icon: React.ReactNode | (() => React.ReactNode)) => {
  if (typeof icon === 'function') {
    return icon();
  }
  return icon;
};
/**
 * Shared sidebar component
 */
function Sidebar() {
  const sidebarReference = useRef<HTMLDivElement>(null);
  const [expandSidebar, setExpandSidebar] = useState<boolean>(false);
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const locate = useLocation();
  const currentPath = locate.pathname;
  const parts = currentPath.split('/');
  const slicedString = parts.slice(0, 3).join('/');
  /**
   * Shared sidebar component
   */
  const getToggleIcons = () => {
    if (theme === 'light') {
      return {
        openIcon: <ToggleOpenLight />,
        closeIcon: <ToggleOpenDark />,
      };
    }
    return {
      openIcon: <ToggleCloseDark />,
      closeIcon: <ToggleCloseLight />,
    };
  };
  const { openIcon, closeIcon } = getToggleIcons();
  /**
   * getThemeIcons
   */
  const getThemeIcons = (lightIcon: React.ReactNode, darkIcon: React.ReactNode) => {
    return theme === 'light' ? lightIcon : darkIcon;
  };
  /**
   * sidebar columns
   */
  const getSidebarMenu = () => [
    {
      id: 1,
      label: 'Dashboard',
      isActive: false,
      url: '/ev-admin/dashboard',
      allow: checkPermission(['dashboard']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<DashboardIconLight />, <DashboardIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<DashboardActiveIconLight />, <DashboardActiveIconDark />),
    },
    {
      id: 2,
      label: 'Facility Management',
      isActive: false,
      url: '/ev-admin/facility-management',
      allow: checkPermission(['charging_station']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<FacilityIconLight />, <FacilityIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<FacilityActiveIconLight />, <FacilityActiveIconDark />),
    },
    {
      id: 3,
      label: 'Station Management',
      isActive: false,
      url: '/ev-admin/station-management/approved',
      allow: checkPermission(['charging_station']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<AccountIconLight />, <AccountIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<AccountActiveIconLight />, <AccountActiveIconDark />),
    },
    {
      id: 4,
      label: 'Device Management',
      isActive: false,
      url: '/ev-admin/device-management',
      allow: checkPermission(['charging_point']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<DeviceIconLight />, <DeviceIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<DeviceActiveIconLight />, <DeviceActiveIconDark />),
    },
    {
      id: 5,
      label: 'Dynamic Pricing',
      isActive: false,
      url: '/ev-admin/dynamic-pricing',
      allow: checkPermission(['dynamic_pricing']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<PricingLight />, <PricingDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<PricingActiveLight />, <PricingActiveDark />),
    },
    {
      id: 6,
      label: 'User management',
      isActive: false,
      url: '/ev-admin/user-management/user',
      allow: checkPermission(['user_management']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<UserIconLight />, <UserIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<UserIconActiveLight />, <UserIconActiveDark />),
    },
    {
      id: 7,
      label: 'Guest Charging',
      isActive: false,
      url: '/ev-admin/guest-charging',
      allow: checkPermission(['reports']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<GuestIconLight />, <GuestIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<GuestActiveLight />, <GuestActiveDark />),
    },
    {
      id: 8,
      label: 'Transaction Management',
      isActive: false,
      allow: checkPermission(['transaction_management']),
      url: '/ev-admin/transaction-management',
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<TransactionIconLight />, <TransactionIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () =>
        getThemeIcons(<TransactionActiveIconLight />, <TransactionActiveIconDark />),
    },
    {
      id: 9,
      label: 'Charging Session',
      isActive: false,
      url: '/ev-admin/charging-session',
      allow: true,
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<ChargingSession />, <ChargingSessionDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<ChargingSessionActive />, <ChargingActiveSessionDark />),
    },
    {
      id: 10,
      label: 'Charging Schedule Management',
      isActive: false,
      url: '/ev-admin/schedule-management/list',
      allow: checkPermission(['charging_schedule']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<ScheduleIconLight />, <ScheduleIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<ScheduleActiveIconLight />, <ScheduleActiveIconDark />),
    },
    {
      id: 11,
      label: 'Maintenance Scheduling',
      isActive: false,
      url: '/ev-admin/maintenance-scheduling/schedule',
      allow: checkPermission(['schedule_maintenance']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<MaintenanceIconLight />, <MaintenanceIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () =>
        getThemeIcons(<MaintenanceActiveIconLight />, <MaintenanceActiveIconDark />),
    },
    {
      id: 12,
      label: 'Reports',
      isActive: false,
      url: '/ev-admin/reports',
      allow: checkPermission(['reports']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<ReportIconLight />, <ReportIconDark />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<ReportActiveLight />, <ReportActiveDark />),
    },
    {
      id: 13,
      label: 'Virtual Load Balancer',
      isActive: false,
      url: '/ev-admin/vlbc',
      allow: checkPermission(['reports']),
      /**
       * svg icon
       */
      svgIcon: () => getThemeIcons(<VlbcIconLight />, <VlbcActiveLight />),
      /**
       * active icon
       */
      activeSvgIcon: () => getThemeIcons(<VlbcActiveLight />, <VlbcIconLight />),
    },
  ];
  const [sidebarMenu, setSideBarMenu] = useState<MenuItem[]>(getSidebarMenu());
  useEffect(() => {
    setSideBarMenu(getSidebarMenu());
  }, [theme]);

  /**
   * Function to navigate to pages based on menu click
   * @param url
   */
  const handleMenuClick = (url: string) => {
    setSideBarMenu((previous) =>
      previous.map((menu) => ({
        ...menu,
        isActive: menu.url === url,
      })),
    );
    navigate(url);
  };

  // Set the active page when screen refresh
  useEffect(() => {
    setSideBarMenu((previousValue) =>
      previousValue.map((menu) => {
        let updatedMenu;
        if (menu.url.includes(slicedString)) {
          updatedMenu = {
            ...menu,
            isActive: true,
          };
        } else {
          updatedMenu = {
            ...menu,
            isActive: false,
          };
        }
        return updatedMenu;
      }),
    );
  }, [currentPath]);

  useEffect(() => {
    /**
     * Close popup
     */
    const handleClickOutside = (event: MouseEvent) => {
      if (sidebarReference.current && !sidebarReference.current.contains(event.target as Node)) {
        setExpandSidebar(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="sidebar-wrap">
      <div
        className={`sidebar-container ${expandSidebar ? 'expand' : 'close'}`}
        ref={sidebarReference}>
        <div
          className={`toggle-button ${expandSidebar ? 'expand' : ''}`}
          role="presentation"
          onClick={() => setExpandSidebar(!expandSidebar)}>
          <span
            role="presentation"
            onClick={() => setExpandSidebar(true)}
            className={`toggle-icon ${expandSidebar ? 'open-disable' : 'open-active'}`}>
            {/* <ToggleOpenLight /> */}
            {openIcon}
          </span>
          <span
            role="presentation"
            onClick={() => setExpandSidebar(false)}
            className={`toggle-icon ${expandSidebar ? 'active' : 'disable'}`}>
            {/* <ToggleCloseLight /> */}
            {closeIcon}
          </span>
        </div>
        <div className="sidebar-menus">
          {sidebarMenu?.map(
            (menu) =>
              menu.allow && (
                <div
                  className={`sidebar-menu ${expandSidebar ? 'expand' : 'close'} ${menu.isActive ? 'active' : 'in-active'}`}
                  key={menu?.id}
                  role="presentation"
                  onClick={() => handleMenuClick(menu.url)}>
                  <div className={`menu-wrap ${menu.isActive ? 'active' : 'in-active'}`}>
                    <div
                      className={`menu-icon-container ${menu.isActive ? 'active' : 'in-active'}`}>
                      {/* <span>{menu.isActive ? menu.activeSvgIcon : menu.svgIcon}</span> */}
                      <span>{renderIcon(menu.isActive ? menu.activeSvgIcon : menu.svgIcon)}</span>
                    </div>
                    <span
                      className={`menu-label ${expandSidebar ? 'expand' : 'close'} ${menu.isActive ? 'active' : 'in-active'}`}>
                      {menu.label}
                    </span>
                  </div>
                </div>
              ),
          )}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
